export const API_PATH_ApiDeviceMgmtDeviceUpdate = '/services/devices-mgtm/apiDeviceMgmtDeviceUpdate';
